import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {Checkbox, Popup} from "semantic-ui-react";
import { Icon } from 'semantic-ui-react';
import {Link} from "react-router-dom";
import {selectSomeKYC} from "../../actions/ServicesActions";
import MARVEL from "../../../../common/utils/MarvelUrls";
import {countriesListFormatter} from "../../../../common/utils/CountriesListFormatter";
import {SortFields} from "../../constants/ServiceActionConstants";
import LastUpdated from '../../../../common/partials/LastUpdated/LastUpdated';

export class KYCListRow extends React.Component {

    static propTypes = {
        key: PropTypes.number,
        serviceID: PropTypes.string,
        serviceName: PropTypes.string,
        serviceConfigName: PropTypes.string,
        associatedCountries: PropTypes.array,
        perUnitCost: PropTypes.number,
        pricingModel: PropTypes.string,
        status: PropTypes.number,
        dataProviderName: PropTypes.string,
        sourceTypes: PropTypes.string,
        currency: PropTypes.string,
        isApproved: PropTypes.number,
        isSelected: PropTypes.bool,
        lastUpdated: PropTypes.string,
    }

    handleCheckboxSelect = (e, {checked}) => {
        this.props.selectSomeKYC(this.props.serviceID, checked);
    }

    get checkbox() {
        return (
            <td className="low-width">
                <Checkbox
                    checked={this.props.isSelected}
                    onChange={this.handleCheckboxSelect}
                />
            </td>
        );
    }

    get isApproved() {
        const { isApproved } = this.props;
        return (
            <td className="low-width">
                {isApproved === 1
                    ? null
                    : (<Popup
                        content='Service Not Approved'
                        trigger={<Icon color="orange" name="warning sign"/>}
                    />)}
            </td>
        );
    }

    get serviceName() {
        const { serviceName, serviceConfigName, serviceID, kycSortKey } = this.props;
        let classnames = ""
        if (kycSortKey === SortFields.SERVICE_NAME) {
            classnames += "current-sort"
        }
        return (
            <td className={classnames}>
                <Link to={{pathname: MARVEL.VERITAS.kyc + serviceID}} key={serviceID}>
                    <p className="service-name">
                        <b>{serviceName}</b>
                    </p>
                    <p className="service-config">
                        ({serviceConfigName})
                    </p>
                </Link>
            </td>
        );
    }

    get sourceTypes() {
        const { sourceTypes } = this.props;
        let formattedSourceTypes = "";
        if (sourceTypes !== null && sourceTypes !== undefined) {
            formattedSourceTypes = sourceTypes.split(",").join(", ");
        }
        return (
            <td>{formattedSourceTypes}</td>
        );
    }

    get country() {
        const { associatedCountries } = this.props;
        let formattedCountryList = ""

        if (associatedCountries !== null) {
            formattedCountryList = countriesListFormatter(associatedCountries)
        }

        return (
            <td>{formattedCountryList}</td>
        );
    }

    get cost() {
        const { perUnitCost, currency } = this.props;
        let formattedCost = "";
        if (perUnitCost !== null) {
            const costFloat = parseFloat(perUnitCost);
            formattedCost = costFloat.toFixed(2);
        }

        return (
            <td>
                <span className="uppercase">{currency}</span>
                {" "}{formattedCost}
            </td>
        );
    }

    get pricingModel() {
        const { pricingModel } = this.props;
        const formattedPricingModel = pricingModel
            ? pricingModel.charAt(0).toUpperCase() + pricingModel.slice(1)
            : "";

        return (
            <td>{formattedPricingModel}</td>
        );
    }

    get status() {
        const { status, kycSortKey } = this.props;
        let classnames = ""
        if (kycSortKey === SortFields.STATUS) {
            classnames += "current-sort"
        }
        return (
            <td className={classnames}>
                {status === 1
                    ? "Integrated"
                    : "Not Integrated"}
            </td>
        );
    }

    get lastUpdated() {
        const { lastUpdated, kycSortKey } = this.props;
        let classnames = ""
      
        if (kycSortKey === SortFields.LAST_UPDATED) {
            classnames += "current-sort"
        }
        return (
            <td className={classnames}>
                <LastUpdated lastUpdated={lastUpdated} type="medium" />
            </td>
        )
    }

    render() {

        return (
            <tr>
                {this.checkbox}
                {this.isApproved}
                {this.serviceName}
                {this.country}
                {this.sourceTypes}
                {this.status}
                {this.lastUpdated}
            </tr>
        )
    }
}

const mapStateToProps = (state) => ({
    all_kyc_selected: state.veritas.services.all_kyc_selected,
    kycSortKey: state.veritas.services.kycSortKey,
});

const mapDispatchToProps = dispatch => ({
    selectSomeKYC: (serviceId, isSelected) => {dispatch(selectSomeKYC(serviceId, isSelected))},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(KYCListRow)
